module.exports = __webpack_public_path__ + "img/ic_save_nor@2x.fc11bcc.png";